import { Designer } from './designer';

// TODO: use focus-tracker replace
class Focusing {
  focusDesigner?: Designer;
}

export const focusing = new Focusing();
